module.exports = __webpack_public_path__ + "img/c980.2af92600.2af92600.png";